// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3iEIv","content":"styles_content__3vLEf","selectAll":"styles_selectAll__20KNe"};